import { LOGOUT, UNAUTHORIZED } from "constants/auth.constants";

const initialState = {
  loading: false,
  success: null,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT.REQUEST:
      return {
        ...state,
        loading: true,
        success: null,
        error: null,
      };
    case LOGOUT.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case LOGOUT.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.data,
      };
    case UNAUTHORIZED:
      return initialState;
    default:
      return state;
  }
};

export default reducer;